/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import SkeletonCommon from '@dtvgo/skeleton';

/* Styles */
import './FeaturedCarouselSkeleton.scss';

function FeaturedCarouselSkeleton({ contained = false }) {
  return (
    <div className={`dtv-html5-featured-carousel-skeleton ${contained ? 'dtv-html5-featured-carousel-skeleton--contained' : ''}`}>
      <SkeletonCommon className="dtv-html5-featured-carousel-skeleton__main-card" />
      <SkeletonCommon className="dtv-html5-featured-carousel-skeleton__secondary-card" />
    </div>
  );
}

FeaturedCarouselSkeleton.propTypes = {
  contained: PropTypes.bool,
};

export default memo(FeaturedCarouselSkeleton);
